
const coloresBase = [
    '#1565C0', '#E65100', '#2E7D32', '#6A1B9A', '#00838F',
    '#0288D1', '#C62828', '#F57F17', '#AD1457', '#4527A0',
    '#37474F', '#4E342E', '#00695C', '#283593', '#558B2F',
    '#BF360C', '#0277BD', '#6D4C41', '#00897B', '#1976D2',
];

export const GetColorMap = ( actividades: string[] ): Record<string, string> => {
    
    return Object.fromEntries(
        actividades.map( ( a, i ) => [ a, coloresBase[ i % coloresBase.length ] ] )
    );
};
